function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import Immutable from 'seamless-immutable';
import any from 'ramda/src/any';
import descend from 'ramda/src/descend';
import clone from 'ramda/src/clone';
import compose from 'ramda/src/compose';
import concat from 'ramda/src/concat';
import filter from 'ramda/src/filter';
import flatten from 'ramda/src/flatten';
import indexOf from 'ramda/src/indexOf';
import isEmpty from 'ramda/src/isEmpty';
import map from 'ramda/src/map';
import min from 'ramda/src/min';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import prop from 'ramda/src/prop';
import propEq from 'ramda/src/propEq';
import sortBy from 'ramda/src/sortBy';
import sortWith from 'ramda/src/sortWith';
import split from 'ramda/src/split';
import sum from 'ramda/src/sum';
import values from 'ramda/src/values';
import { createSelector } from 'reselect';
import { CurrentBusinessUnitSelector } from 'invision-core/src/components/session/businessunit.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { MetadataCodeTypeDictionarySelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { OfferingMetadataByIdSelector, OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { EMPTY_ARRAY, EMPTY_OBJECT } from 'invision-core/src/constants/common.constants';
import { DiscountsMetadataMapSelector } from 'invision-core/src/components/metadata/discounts/discounts.selectors';
import { BRI_ACTIVATION_STATUS } from 'invision-core/src/constants/pricing.plan.constants';
import { DecisionTypes } from '../../components/wizards/steps/decisions/decisions.constants';
import { BILLER_RULE_CYCLE_LEVEL, BILLER_RULE_INSTANCE_TYPE, PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE } from '../../customercare.constants';
import CustomerCareKeys from '../../locales/keys';
import { getFilteredBillerRuleDetailsForBriId } from '../helpers/offer.ordering.wizard.selector.helper';
import { SelectedContractSelector } from './contract.selectors';
import { SelectedOfferAccountDetailsSelector } from './customer.convergent.biller.selectors';
import { ALLOWABLE_ACTIONS, GENERAL_STATUSES } from '../../components/shared/constants/general.status.constants';
import { CustomerInfoSelector, IsCustomerStepSelector, IsCheckoutStepSelector } from './new.connect.wizard.selectors';
import { CustomerStoreSelector, SelectedCustomerHomeCountrySelector } from './customer.selectors';
import { SelectedInventoryRegionSelector, SelectedInventoryStoresSelector, InventoryRegionFilterSelector, InventoryStoresTableDataSelector, FormattedInventoryStoresSelector, OfferingOrderAsyncIdSelector, SelectedOrderExecutionOptionsSelector } from './offering.order.selectors';
import { filterByCountry, filterStatesByCountry, findAndAttachStateName, getChargeAmount, getDiscountDisplayAmount, isChargeOverridableOption, isFinancedShoppingCartItem, mapCodesAdditionalProperties, reduceByState, selectFutureDatedOrderConfigurationIsAllowedForCurrentBusinessUnit, selectFutureDatedOrderConfigurationMaxDateForCurrentBusinessUnit, setDownPaymentProperties } from './selected.offering.order.selector.helper';
import { IMMUTABLE_EMPTY_ARRAY } from '../constants/common.constants';
import { getUniqueNonGuidServiceIdentifiers } from '../helpers/add.offer.wizard.selectors.helpers';
import { getDiscountTooltipModel } from '../../components/shared/tooltipTemplates/discount.tooltip.helper';
var SelectedOfferingSelector = function SelectedOfferingSelector(state) {
  return state.customercare.offeringOrder.data.selectedOffering;
};
export var SelectedOfferingPickupIdSelector = createImmutableSelector([SelectedOfferingSelector], function (selectedOffering) {
  return selectedOffering.subscriberPhysicalInventoryPickupDetails || null;
});
export var ROCOfferIdDataSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.data.rocResponseOfferId;
});
var DecisionsDataSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.data.decisions.data;
});
export var SelectedOfferingDataSelector = createImmutableSelector([SelectedOfferingSelector], function (selectedOffering) {
  return selectedOffering.data;
});
export var SelectedOfferingShoppingCartSelector = createImmutableSelector([SelectedOfferingDataSelector], function (selectedOfferingShoppingCartData) {
  return selectedOfferingShoppingCartData.shoppingCart;
});
export var SelectedOfferingShoppingCartOfferingsSelector = createImmutableSelector([SelectedOfferingShoppingCartSelector], function (selectedOfferingShoppingCart) {
  return selectedOfferingShoppingCart.Offerings || EMPTY_ARRAY;
});
export var IsSelectedOfferingChangeable = createImmutableSelector([SelectedOfferingShoppingCartOfferingsSelector], function (selectedOfferingShoppingCartOfferings) {
  return pathOr(false, ['0', 'IsChangeable'], selectedOfferingShoppingCartOfferings);
});
export var SelectedOfferingShoppingCartItemsSelector = createImmutableSelector([SelectedOfferingShoppingCartSelector], function (shoppingCartItemsData) {
  return shoppingCartItemsData.Items && shoppingCartItemsData.Items.length ? shoppingCartItemsData.Items : IMMUTABLE_EMPTY_ARRAY;
});
export var SelectedOfferingServiceIdentifiersSelector = createImmutableSelector([SelectedOfferingShoppingCartItemsSelector, MetadataCodeTypeDictionarySelector(CODES.RegularExpression), MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute)], function (shoppingCartItems, regularExpressionCodeTable, serviceAttributeCodeTable) {
  var serviceAttributes = compose(flatten, pluck('ServiceAttributes'))(shoppingCartItems);
  return getUniqueNonGuidServiceIdentifiers(serviceAttributes, serviceAttributeCodeTable, regularExpressionCodeTable);
});
export var SelectedOfferDevicePaymentOptionsSelector = createSelector([SelectedOfferingSelector], function (offering) {
  return pathOr(null, ['data', 'devicePaymentOptions'], offering);
});
export var SelectedOfferPurchaseOrderNumberSelector = createSelector([SelectedOfferingSelector], function (offering) {
  return pathOr(null, ['data', 'purchaseOrderNumber'], offering);
});
export var GetMaxDateForFutureDatedOrder = createSelector([MetadataCodeTypeSelector(CODES.FutureDatedOrderConfiguration)], function (fdoConfiguration) {
  return selectFutureDatedOrderConfigurationMaxDateForCurrentBusinessUnit(fdoConfiguration);
});
export var IsFutureDatedOrderAllowedInBunt = createSelector([MetadataCodeTypeSelector(CODES.FutureDatedOrderConfiguration)], function (fdoConfiguration) {
  return selectFutureDatedOrderConfigurationIsAllowedForCurrentBusinessUnit(fdoConfiguration);
});
export var SelectedOfferExternalContractIdSelector = createSelector([SelectedOfferingSelector], function (offering) {
  return pathOr(null, ['data', 'externalContractId'], offering);
});
export var SubmittedOrderSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.data.modifiedOrder;
});
export var SubmittedOrderErrorSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.lastAttemptError;
});
export var SubmittedOrderCurrencyCodeSelector = createSelector([SubmittedOrderSelector], function (createdOrder) {
  return createdOrder && createdOrder.CurrencyCode ? createdOrder.CurrencyCode : 'USD';
});
export var AttributesDataSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.data.attributes.data;
});
export var PageDisplayOrderSelector = createSelector([DecisionsDataSelector], function (decisionsData) {
  return decisionsData.pageDisplayOrder;
});
export var PagesSelector = createSelector([DecisionsDataSelector], function (decisionsData) {
  return decisionsData.pages;
});
export var PagesIsFetchingDataSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.isFetchingData;
});
export var IsUpdatingCartSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.isUpdatingCart;
});
export var DecisionsRequiringAffectedServicesResolutionSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.decisionsRequiringAffectedServicesResolution;
});
export var IsFetchingBillerRuleInstanceDiscountContextSelector = createImmutableSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.isFetchingBillerRuleInstanceDiscountContext;
});
export var DiscretionaryDiscountTableDataSelector = createSelector([DecisionsDataSelector, DiscountsMetadataMapSelector], function (decisionsData, discountsMetadataMap) {
  var discretionaryDiscounts = clone(pathOr(EMPTY_ARRAY, ['selectedBillerRuleInstanceDiscountContext', 'DiscretionaryDiscounts'], decisionsData));
  return !discretionaryDiscounts ? EMPTY_ARRAY : discretionaryDiscounts.map(function (discretionaryDiscount) {
    var discretionaryDiscountMetadata = discountsMetadataMap[pathOr(undefined, ['DiscountId', 'Value'], discretionaryDiscount)] || EMPTY_OBJECT;
    return {
      amount: getDiscountDisplayAmount(discretionaryDiscountMetadata),
      currency: discretionaryDiscountMetadata.Currency,
      discountAmountType: "".concat(discretionaryDiscountMetadata.Type),
      discountId: pathOr(null, ['DiscountId', 'Value'], discretionaryDiscount),
      isSelected: false,
      isDisabled: false,
      isOverridable: discretionaryDiscountMetadata.AllowDiscountOverride,
      name: discretionaryDiscountMetadata.StorefrontText || discretionaryDiscountMetadata.Name,
      savings: discretionaryDiscount.DiscountAmount
    };
  });
});
export var RegularDiscountTableDataSelector = createSelector([DecisionsDataSelector, DiscountsMetadataMapSelector], function (decisionsData, discountsMetadataMap) {
  var regularDiscounts = clone(pathOr(EMPTY_ARRAY, ['selectedBillerRuleInstanceDiscountContext', 'BillerRuleInstanceDiscounts'], decisionsData));
  var selectedGlobalDiscounts = clone(pathOr(EMPTY_ARRAY, ['selectedBillerRuleInstanceDiscountContext', 'GlobalDiscounts'], decisionsData)).filter(function (globalDiscount) {
    return (decisionsData.selectedBriSelectedDiscounts || []).some(function (selectedBriSelectedDiscount) {
      return "".concat(selectedBriSelectedDiscount.DiscountId) === globalDiscount.DiscountId.Value;
    });
  }).map(function (globalDiscount) {
    return Object.assign({}, globalDiscount, {
      isGlobalDiscount: true
    });
  });
  var regularAndGlobalDiscounts = [].concat(_toConsumableArray(regularDiscounts), _toConsumableArray(selectedGlobalDiscounts));
  return !regularAndGlobalDiscounts ? EMPTY_ARRAY : regularAndGlobalDiscounts.map(function (discount) {
    var discountMetadata = discountsMetadataMap[pathOr(undefined, ['DiscountId', 'Value'], discount)] || EMPTY_OBJECT;
    return {
      amount: getDiscountDisplayAmount(discountMetadata),
      currency: discountMetadata.Currency,
      discountAmountType: "".concat(discountMetadata.Type),
      discountId: pathOr(null, ['DiscountId', 'Value'], discount),
      isDisabled: !!discount.isGlobalDiscount,
      isGlobalDiscount: discount.isGlobalDiscount,
      isOverridable: discountMetadata.AllowDiscountOverride,
      isSelected: false,
      name: discountMetadata.StorefrontText || discountMetadata.Name,
      savings: discount.DiscountAmount
    };
  });
});
export var DecisionsRequireAffectedServicesResolutionSelector = createSelector([DecisionsRequiringAffectedServicesResolutionSelector], function (decisionsRequiringAffectedServicesResolution) {
  var unresolvedDecisionsRequiringAffectedServicesResolution = decisionsRequiringAffectedServicesResolution.filter(function (decision) {
    return !decision.resolved;
  });
  return !!unresolvedDecisionsRequiringAffectedServicesResolution.length;
});
export var PagesIsFetchingDecisionOptionServiceIdsSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.isFetchingDecisionOptionServiceIds;
});
export var SelectedPageIdSelector = createSelector([DecisionsDataSelector], function (decisionsData) {
  return decisionsData.selectedPageId;
});
var PagesInOrderSelector = createSelector([PageDisplayOrderSelector, PagesSelector, SelectedPageIdSelector], function (pageDisplayOrder, pages, selectedPageId) {
  return pageDisplayOrder.map(function (pageId) {
    return pages[pageId].merge({
      selected: pageId === selectedPageId
    }, {
      deep: true
    });
  });
});
export var DecisionsSelector = createSelector([DecisionsDataSelector], function (decisionsData) {
  return decisionsData.decisionsMap;
});
export var ServicesForRemovalSelector = createSelector([DecisionsSelector], function (decisionsMap) {
  if (decisionsMap) {
    var services = [];
    var decisionValues = values(decisionsMap);
    if (decisionValues && decisionValues.length) {
      decisionValues.forEach(function (decision) {
        if (decision.Options && decision.Options.length) {
          decision.Options.forEach(function (option) {
            if (option.SelectedServicesForRemoval && option.SelectedServicesForRemoval.length) {
              option.SelectedServicesForRemoval.forEach(function (service) {
                services.push(service.Value);
              });
            }
          });
        }
      });
    }
    return services;
  } else {
    return IMMUTABLE_EMPTY_ARRAY;
  }
});
export var ServicesBeingRemovedHaveServiceFeaturesSelector = createSelector([ServicesForRemovalSelector, SelectedOfferAccountDetailsSelector], function (servicesForRemoval, selectedOffering) {
  return servicesForRemoval.some(function (service) {
    if (pathOr(0, ['ServiceFeatures', 'length'], selectedOffering)) {
      return selectedOffering.ServiceFeatures.filter(function (feature) {
        return feature.Status === GENERAL_STATUSES.ACTIVE;
      }).find(function (feature) {
        return feature.ServiceAttributeValues.find(function (attribute) {
          return attribute.Value === service;
        });
      });
    }
  });
});
function isQuantityDecisionInvalid(options) {
  var min = options[0].MinimumQuantity;
  var max = options[0].MaximumQuantity;
  var totalQuantities = sum(pluck('Quantity')(options));
  return min > totalQuantities || totalQuantities > max;
}
function isQuantityDecisionGroupsInvalid(options, decision) {
  var test = pluck('Quantity')(options).map(function (option) {
    return isNaN(option) ? 0 : option;
  });
  var totalQuantities = sum(test);
  return decision.MinimumQuantity > totalQuantities || totalQuantities > decision.MaximumQuantity;
}
function isQuantityDecisionGroupsItemsInvalid(options) {
  return !!options.find(function (element) {
    return element.Items.some(function (item) {
      return item.hasError;
    }) || false;
  });
}
function isStandaloneDecisionInvalid(options, decision) {
  var totalQuantities = sum(pluck('Quantity')(options));
  return totalQuantities > min(pathOr(0, ['MaximumQuantity'], decision), pathOr(0, ['RemainingOrderableQuantity'], decision));
}
export var ShoppingCartSelector = createSelector([SelectedOfferingSelector, SelectedContractSelector, SelectedOfferPurchaseOrderNumberSelector, SelectedOfferExternalContractIdSelector, SelectedOfferDevicePaymentOptionsSelector, SelectedOrderExecutionOptionsSelector], function (selectedOfferingStore, selectedContract, selectedOfferPurchaseOrderNumber, selectedOfferExternalContractId, devicePaymentOptions, executionOptions) {
  var shoppingCart = clone(pathOr({}, ['data', 'shoppingCart'], selectedOfferingStore));
  if (shoppingCart.Items || shoppingCart.AddItems || shoppingCart.ModifyItems || shoppingCart.RemoveItems) {
    populatePurchaseOrderNumberAndEffectiveDate(selectedOfferPurchaseOrderNumber, shoppingCart.Items, executionOptions);
    populatePurchaseOrderNumberAndEffectiveDate(selectedOfferPurchaseOrderNumber, shoppingCart.AddItems, executionOptions);
    populatePurchaseOrderNumberAndEffectiveDate(selectedOfferPurchaseOrderNumber, shoppingCart.ModifyItems, executionOptions);
    populatePurchaseOrderNumberAndEffectiveDate(selectedOfferPurchaseOrderNumber, shoppingCart.RemoveItems, executionOptions);
    populateDownPaymentAmount(devicePaymentOptions, shoppingCart.Items, shoppingCart.AddItems);
    populateDownPaymentAmount(devicePaymentOptions, shoppingCart.Items, shoppingCart.RemoveItems);
    if (selectedContract) {
      populateOrderContractId(selectedContract, shoppingCart.Items);
      populateOrderContractId(selectedContract, shoppingCart.AddItems);
      populateOrderContractId(selectedContract, shoppingCart.ModifyItems);
      populateOrderContractId(selectedContract, shoppingCart.RemoveItems);
      populateExternalContractId(selectedOfferExternalContractId, shoppingCart.Items);
      populateExternalContractId(selectedOfferExternalContractId, shoppingCart.AddItems);
      populateExternalContractId(selectedOfferExternalContractId, shoppingCart.ModifyItems);
      populateExternalContractId(selectedOfferExternalContractId, shoppingCart.RemoveItems);
    }
  }
  return shoppingCart;
});
export var RemoveItemsSelector = createSelector([ShoppingCartSelector], function (shoppingCart) {
  return pathOr(null, ['RemoveItems'], shoppingCart);
});
export var PagesWithDecisionsSelector = createSelector([PagesInOrderSelector, DecisionsSelector, OfferingMetadataPricingPlansSelector, DiscountsMetadataMapSelector, RemoveItemsSelector], function (pages, decisionsMap, offeringMetadataPricingPlans, discountsMetadataMap, removedOptionItems) {
  if (!pages) {
    return;
  }
  return pages.map(function (page) {
    var decisions = page.decisionIds.map(function (decisionId) {
      var providesPlansWarning = '';
      if (removedOptionItems && removedOptionItems.length) {
        var newlyRemovedItems = decisionsMap[decisionId].Options.filter(function (option) {
          return removedOptionItems.find(function (item) {
            return item.OfferingOptionPriceId === option.Id && item.PricingPlanId === option.PricingPlanId && offeringMetadataPricingPlans[option.PricingPlanId] && offeringMetadataPricingPlans[option.PricingPlanId].ServiceRelationshipType === PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE.PROVIDES;
          });
        });
        if (newlyRemovedItems.length) {
          providesPlansWarning = newlyRemovedItems.length > 1 ? i18n.translate(CustomerCareKeys.DECISIONS.REMOVE_PLAN_ASSOCIATIONS_GENERIC) : i18n.translate(CustomerCareKeys.DECISIONS.REMOVE_PLAN_ASSOCIATIONS_SINGLE, {
            pricingPlanName: offeringMetadataPricingPlans[newlyRemovedItems[0].PricingPlanId].PricingPlanName
          });
        }
      }
      if (decisionsMap[decisionId].DecisionType === DecisionTypes.QUANTITY) {
        return Object.assign({}, decisionsMap[decisionId], {
          hasError: isQuantityDecisionInvalid(decisionsMap[decisionId].Options),
          providesPlansWarning: providesPlansWarning
        });
      } else if (decisionsMap[decisionId].DecisionType === DecisionTypes.GROUP && (decisionsMap[decisionId].MaximumQuantity > 1 || decisionsMap[decisionId].MaximumQuantity > decisionsMap[decisionId].MinimumQuantity)) {
        return Object.assign({}, decisionsMap[decisionId], {
          hasError: isQuantityDecisionGroupsInvalid(decisionsMap[decisionId].Options, decisionsMap[decisionId]),
          providesPlansWarning: providesPlansWarning
        });
      } else if (decisionsMap[decisionId].DecisionType === DecisionTypes.STANDALONE) {
        return Object.assign({}, decisionsMap[decisionId], {
          hasError: isStandaloneDecisionInvalid(decisionsMap[decisionId].Options, decisionsMap[decisionId]),
          providesPlansWarning: providesPlansWarning
        });
      } else {
        return Object.assign({}, decisionsMap[decisionId], {
          providesPlansWarning: providesPlansWarning
        });
      }
    });
    var sortByDisplayOrder = sortBy(prop('DisplayOrder'));
    var pageMap = page.set('decisions', sortByDisplayOrder(getDecisionsViewModel(decisions, offeringMetadataPricingPlans, discountsMetadataMap))).set('Name', page.Name || i18n.translate(CustomerCareKeys.DECISIONS.UNNAMED_PAGE));
    return pageMap;
  });
});
function getDecisionsViewModel(decisions, offeringMetadataPricingPlans, discountsMetadataMap) {
  return decisions.map(function (decision) {
    var options = decision.Options.map(function (option) {
      return Object.assign({}, option, {
        BillerRuleInstanceThumbnails: addCustomPropertiesToBillerRuleInstance(option, option.BillerRuleInstanceThumbnails, offeringMetadataPricingPlans, discountsMetadataMap)
      });
    });
    return Object.assign({}, decision, {
      Options: options
    });
  });
}
function addCustomPropertiesToBillerRuleInstance(option, billerRuleInstanceThumbnails, offeringMetadataPricingPlans, discountsMetadataMap) {
  return billerRuleInstanceThumbnails.map(function (billerRuleInstanceThumbnail) {
    var billerRuleInstanceObj = Object.assign({}, billerRuleInstanceThumbnail, {
      discounts: EMPTY_ARRAY,
      triggers: EMPTY_ARRAY
    });
    if ((billerRuleInstanceThumbnail.selectedDiscountsInfo || []).length && !isEmpty(discountsMetadataMap)) {
      billerRuleInstanceObj.discounts = getDiscounts(billerRuleInstanceThumbnail.selectedDiscountsInfo || [], discountsMetadataMap);
    }
    if (!isEmpty(offeringMetadataPricingPlans)) {
      var isInactiveUntilFirstUseBri = (option.BillerRuleInstanceThumbnails || []).some(function (billerRuleInstanceThumbnail) {
        return billerRuleInstanceThumbnail.Status === BRI_ACTIVATION_STATUS.INACTIVE;
      });
      if (isInactiveUntilFirstUseBri) {
        var pricingPlanBillerRuleInstances = (offeringMetadataPricingPlans[option.PricingPlanId] || {}).PricingPlanBillerRuleInstances;
        if (pricingPlanBillerRuleInstances) {
          billerRuleInstanceObj.triggers = (pricingPlanBillerRuleInstances.TriggerBillerRuleInstances || []).filter(function (triggerBillerRuleInstance) {
            return (triggerBillerRuleInstance.Actions || []).some(function (action) {
              return action.BillerRuleConfigurationId === billerRuleInstanceThumbnail.BillerRuleConfigurationId;
            });
          });
        }
      }
    }
    return billerRuleInstanceObj;
  });
}
function getDiscounts(selectedDiscountsInfo, discountsMetadataMap) {
  var discounts = [];
  selectedDiscountsInfo.forEach(function (discount) {
    var discountMetadata = discountsMetadataMap[discount.DiscountId];
    if (discountMetadata) {
      var discountTooltipModel = getDiscountTooltipModel(discount, discountMetadata.Currency, discountsMetadataMap);
      discounts.push(discountTooltipModel);
    }
  });
  return selectedDiscountsInfo.length && !isEmpty(discountsMetadataMap) ? discounts : EMPTY_ARRAY;
}
var EMPTY_MAPPED_DECISIONS = [];
export var DecisionsRequiringAffectedServicesResolutionMappedForSelectedPageSelector = createSelector([DecisionsRequiringAffectedServicesResolutionSelector, PagesWithDecisionsSelector], function (decisionsRequiringAffectedServicesResolution, pagesWithDecisions) {
  var mappedDecisions = [];
  var pageWithDecisions = pagesWithDecisions.find(propEq(true, 'selected'));
  if (pageWithDecisions) {
    pageWithDecisions.decisions.forEach(function (decision) {
      var updatedDecisionOptions = [];
      var filteredDecisionsRequiringAffectedServicesResolution = decisionsRequiringAffectedServicesResolution.filter(propEq(decision.Id, 'decisionId'));
      if (filteredDecisionsRequiringAffectedServicesResolution.length) {
        decision.Options.forEach(function (option) {
          var decisionRequiringAffectedServicesResolution = filteredDecisionsRequiringAffectedServicesResolution.find(propEq(option.Id, 'optionId'));
          if (decisionRequiringAffectedServicesResolution) {
            updatedDecisionOptions.push({
              Id: option.Id,
              Name: option.Name,
              numRequiredSelections: decisionRequiringAffectedServicesResolution.numRequiredSelections,
              serviceIdentifiers: [],
              updatedQuantity: decisionRequiringAffectedServicesResolution.updatedQuantity
            });
          }
        });
      }
      if (updatedDecisionOptions.length) {
        mappedDecisions.push({
          Id: decision.Id,
          Name: decision.Name,
          Options: updatedDecisionOptions
        });
      }
    });
  }
  return mappedDecisions.length ? mappedDecisions : EMPTY_MAPPED_DECISIONS;
});
export var IsFirstDecisionPageSelector = createSelector([PageDisplayOrderSelector, SelectedPageIdSelector], function (pageOrder, selectedPageId) {
  return pageOrder[0] === selectedPageId;
});
export var IsLastDecisionPageSelector = createSelector([PageDisplayOrderSelector, SelectedPageIdSelector], function (pageOrder, selectedPageId) {
  return pageOrder[pageOrder.length - 1] === selectedPageId;
});
export var BackDecisionPageTextSelector = createSelector([IsFirstDecisionPageSelector, PageDisplayOrderSelector, SelectedPageIdSelector, PagesSelector], function (isFirstPage, pageOrder, selectedPageId, pages) {
  return isFirstPage || selectedPageId === null || pageOrder.length === 0 || indexOf(selectedPageId, pageOrder) < 0 ? '' : pages[pageOrder[indexOf(selectedPageId, pageOrder) - 1]].Name || i18n.translate(CustomerCareKeys.DECISIONS.UNNAMED_PAGE);
});
export var NextDecisionPageTextSelector = createSelector([IsLastDecisionPageSelector, PageDisplayOrderSelector, SelectedPageIdSelector, PagesSelector], function (isLastPage, pageOrder, selectedPageId, pages) {
  return isLastPage || selectedPageId === null || pageOrder.length === 0 ? '' : pages[pageOrder[+1 + indexOf(selectedPageId, pageOrder)]].Name || i18n.translate(CustomerCareKeys.DECISIONS.UNNAMED_PAGE);
});
export var CurrentAttributeFormName = createSelector([AttributesDataSelector], function (attributesData) {
  return attributesData.currentAttributeFormName;
});
export var CurrentAttributesValidationStatuses = createSelector([AttributesDataSelector], function (attributesData) {
  return attributesData.attributesValidationStatuses;
});
export var AttributeFormSubmittedSelector = createSelector([AttributesDataSelector], function (attributesData) {
  return attributesData.attributeFormSubmitted;
});
var EMPTY_ATTRIBUTE_GROUPS = [];
export var AttributeGroupsSelector = createSelector([AttributesDataSelector], function (attributesData) {
  return attributesData.attributeGroups ? attributesData.attributeGroups.asMutable({
    deep: true
  }) : EMPTY_ATTRIBUTE_GROUPS;
});
export var PhysicalAttributeGroupsSelector = createSelector([AttributesDataSelector], function (attributesData) {
  return attributesData.physicalInventoryAttributeGroups ? attributesData.physicalInventoryAttributeGroups.asMutable({
    deep: true
  }) : EMPTY_ATTRIBUTE_GROUPS;
});
export var PhysicalAttributeDecisionsSelector = createImmutableSelector([AttributesDataSelector], function (attributesData) {
  return attributesData.physicalInventoryDecisions ? attributesData.physicalInventoryDecisions : IMMUTABLE_EMPTY_ARRAY;
});
export var SelectedOfferingPhysicalInventoriesSelector = createImmutableSelector([SelectedOfferingShoppingCartItemsSelector, PhysicalAttributeDecisionsSelector], function (shoppingCartItemsData, physicalAttributeDecisions) {
  return shoppingCartItemsData.filter(function (item) {
    return physicalAttributeDecisions.some(function (attribute) {
      return item.PricingPlanId === attribute.PricingPlanId && attribute.DecisionType === DecisionTypes.PHYSICAL_INVENTORY && !attribute.SubscriberProductId;
    });
  });
});
export var AllPhysicalInventoryItemsFromSelectedOffering = createImmutableSelector([SelectedOfferingPhysicalInventoriesSelector], function (shoppingCartItems) {
  var shoppingCartItemsWithPhysicalInventories = shoppingCartItems.filter(function (items) {
    return items.PhysicalInventories;
  });
  return flatten(pluck('PhysicalInventories', shoppingCartItemsWithPhysicalInventories)).map(function (item, index) {
    return {
      DisplayName: item.DisplayName,
      InstanceId: generateKeyFromInventoryItem(item, index),
      InventoryAttributes: item.InventoryAttributes,
      InventoryTypeId: item.InventoryTypeId,
      MakeId: item.MakeId,
      ModelId: item.ModelId,
      Quantity: 1
    };
  });
});
export var IsSendToStoreButtonEnabledSelector = createSelector([SelectedOfferingPhysicalInventoriesSelector, IsCustomerStepSelector, IsCheckoutStepSelector, OfferingOrderAsyncIdSelector], function (physicalInventory, isCustomerStep, isCheckoutStep, asyncId) {
  return !!((isCustomerStep || isCheckoutStep) && physicalInventory.length && !asyncId);
});
export var InventoryAvailabilitySelector = createSelector([AttributesDataSelector], function (attributesData) {
  return attributesData.availableInventory || EMPTY_ATTRIBUTE_GROUPS;
});
export var AreAnyInventoryUnavailableSelector = createSelector([InventoryAvailabilitySelector], function (inventoryAvailability) {
  return !!inventoryAvailability.find(function (_ref) {
    var Available = _ref.Available;
    return !Available;
  });
});
var filterQuantityDecisions = filter(function (decision) {
  return decision.DecisionType === DecisionTypes.QUANTITY;
});
var filterDecisionGroups = filter(function (decision) {
  return decision.DecisionType === DecisionTypes.GROUP && !(decision.MaximumQuantity > 1 || decision.MaximumQuantity > decision.MinimumQuantity);
});
var filterQuantityDecisionGroups = filter(function (decision) {
  return decision.DecisionType === DecisionTypes.GROUP && (decision.MaximumQuantity > 1 || decision.MaximumQuantity > decision.MinimumQuantity);
});
var filterStandaloneDecisions = filter(function (decision) {
  return decision.DecisionType === DecisionTypes.STANDALONE;
});
var filterSelectedOption = filter(function (option) {
  return option.Selected;
});
var mapQuantityDecision = map(function (decision) {
  var completedQuantityOptions = decision.Options.map(function (option) {
    return {
      Id: split('_', decision.Id)[1],
      CompletedOfferingDecisionInstances: getCompletedOfferingDecisionInstances(option),
      DecisionType: DecisionTypes.QUANTITY,
      SelectedValue: option.Id,
      IsPlanOrServiceSwap: option.isPlanOrServiceSwap,
      Quantity: option.Bulk && option.Quantity > 0 ? 1 : option.Quantity,
      BillerRuleInstanceDetails: getCompletedBillerRuleDetails(option),
      SelectedServicesForRemoval: option.SelectedServicesForRemoval || null,
      ItemDecisions: mapQuantityDecisionGroupItems(option.Items || []),
      SubscriberProductId: pathOr(undefined, ['OfferingDecisionOptionInstances', 0, 'SubscriberProductId'], option)
    };
  });
  return {
    completedQuantityOptions: completedQuantityOptions
  };
});
var mapQuantityDecisionGroupItems = map(function (items) {
  return {
    DecisionGroupOptionItemId: items.DecisionGroupOptionItemId,
    Quantity: items.Quantity
  };
});
var mapQuantityDecisionGroups = map(function (decision) {
  var completedQuantityOptions = decision.Options.map(function (option) {
    return {
      Id: split('_', decision.Id)[1],
      DecisionType: DecisionTypes.GROUP,
      SelectedValue: option.Id,
      OverrideDiscount: option.OverrideDiscount || undefined,
      Quantity: !isNaN(option.Quantity) ? option.Quantity : 0,
      BillerRuleInstanceDetails: getCompletedBillerRuleDetails(option),
      SelectedServicesForRemoval: option.SelectedServicesForRemoval || null,
      ItemDecisions: mapQuantityDecisionGroupItems(option.Items || [])
    };
  });
  return {
    completedQuantityOptions: completedQuantityOptions
  };
});
var mapStandaloneDecision = map(function (decision) {
  var completedStandaloneOptions = decision.Options.map(function (option) {
    return {
      Id: split('_', decision.Id)[1],
      CompletedOfferingDecisionInstances: getCompletedOfferingDecisionInstances(option),
      DecisionType: DecisionTypes.STANDALONE,
      SelectedValue: option.Id,
      IsPlanOrServiceSwap: option.isPlanOrServiceSwap,
      Quantity: option.Bulk && option.Quantity > 0 ? 1 : option.Quantity,
      BillerRuleInstanceDetails: getCompletedBillerRuleDetails(option),
      SelectedServicesForRemoval: option.SelectedServicesForRemoval || null,
      ItemDecisions: mapQuantityDecisionGroupItems(option.Items || []),
      SubscriberProductId: pathOr(undefined, ['OfferingDecisionOptionInstances', 0, 'SubscriberProductId'], option)
    };
  });
  return {
    completedStandaloneOptions: completedStandaloneOptions
  };
});
function getCompletedOfferingDecisionInstances(option) {
  var completedOfferingDecisionInstances = [];
  if (option.OfferingDecisionOptionInstances) {
    var offeringDecisionOptionInstance = option.OfferingDecisionOptionInstances[0];
    //Currently, API duplicates selectedDiscounts in each offering instance because the application does not yet officially support discounts per instance of an option.
    //I'm mimicking that here.
    for (var instanceIndex = 0; instanceIndex < (option.Quantity || 1); instanceIndex++) {
      if (option.Quantity) {
        var _offeringDecisionOpti;
        completedOfferingDecisionInstances.push(_objectSpread(_objectSpread({}, (offeringDecisionOptionInstance === null || offeringDecisionOptionInstance === void 0 ? void 0 : offeringDecisionOptionInstance.SelectedLifeCycle) && {
          SelectedLifeCycleId: offeringDecisionOptionInstance === null || offeringDecisionOptionInstance === void 0 ? void 0 : (_offeringDecisionOpti = offeringDecisionOptionInstance.SelectedLifeCycle) === null || _offeringDecisionOpti === void 0 ? void 0 : _offeringDecisionOpti.LifeCycleId
        }), {}, {
          SelectedDiscountDecisions: (offeringDecisionOptionInstance.SelectedDiscounts || []).map(function (selectedDiscount) {
            return Object.assign({}, selectedDiscount, {
              DiscountAmount: undefined
            });
          })
        }));
      }
    }
  } else if (option.DefaultSelectedDiscounts) {
    //Currently, API duplicates selectedDiscounts in each offering instance because the application does not yet officially support discounts per instance of an option.
    //I'm mimicking that here.
    for (var _instanceIndex = 0; _instanceIndex < (option.Quantity || 1); _instanceIndex++) {
      completedOfferingDecisionInstances.push({
        SelectedDiscountDecisions: option.DefaultSelectedDiscounts.map(function (defaultSelectedDiscount) {
          return Object.assign({}, defaultSelectedDiscount, {
            DiscountAmount: undefined
          });
        })
      });
    }
  }
  return completedOfferingDecisionInstances.length ? completedOfferingDecisionInstances : undefined;
}
function getCompletedBillerRuleDetails(option) {
  if (option.Bulk || isChargeOverridableOption(option)) {
    var billerRuleDetails = option.BillerRuleInstanceThumbnails.map(function (brit) {
      var _option$BillerRuleDet, _option$BillerRuleDet2;
      var quantity = option.Bulk && option.Quantity > 0 ? (_option$BillerRuleDet = option.BillerRuleDetails) === null || _option$BillerRuleDet === void 0 ? void 0 : (_option$BillerRuleDet2 = _option$BillerRuleDet[0]) === null || _option$BillerRuleDet2 === void 0 ? void 0 : _option$BillerRuleDet2.Quantity : option.Quantity;
      var billerRuleDecisionDetails = getFilteredBillerRuleDetailsForBriId(brit.BillerRuleConfigurationId, option.BillerRuleDetails).reduce(function (acc, billerRuleDetail) {
        if (billerRuleDetail.BillerRuleConfigurationId) {
          acc.push(Object.assign({}, billerRuleDetail, _objectSpread(_objectSpread({
            Amount: billerRuleDetail && typeof billerRuleDetail.Amount === 'number' ? billerRuleDetail.Amount : brit.Amount
          }, (billerRuleDetail === null || billerRuleDetail === void 0 ? void 0 : billerRuleDetail.TermLength) && {
            TermLength: billerRuleDetail.TermLength
          }), {}, {
            Quantity: quantity
          })));
        }
        return acc;
      }, []);
      if (brit.pricingPeriods) {
        billerRuleDecisionDetails = brit.pricingPeriods.map(function (period) {
          return Object.assign({}, period, {
            Quantity: quantity
          });
        });
      }
      if (brit.financeOverrides) {
        billerRuleDecisionDetails = [brit.financeOverrides];
      }
      var filteredBillerRuleDecisions = billerRuleDecisionDetails.filter(function (item) {
        return item.Quantity;
      });

      /** if it's non bulk and there are no price override, then
       * we should not send the BillerRuleInstanceDetails in ROC */
      if (!option.Bulk && !brit.financeOverrides && filteredBillerRuleDecisions.length === 1 && (filteredBillerRuleDecisions[0].Amount === brit.CatalogAmount || filteredBillerRuleDecisions[0].Amount === null)) {
        filteredBillerRuleDecisions = [];
      }
      return {
        BillerRuleConfigurationId: brit.BillerRuleConfigurationId,
        BillerRuleDecisionDetails: filteredBillerRuleDecisions
      };
    });
    return billerRuleDetails.filter(function (item) {
      return item.BillerRuleDecisionDetails.length;
    });
  } else {
    return null;
  }
}
var mapDecisionGroups = map(function (decision) {
  var selectedOption = filterSelectedOption(decision.Options);
  return {
    Id: split('_', decision.Id)[1],
    DecisionType: DecisionTypes.GROUP,
    SelectedValue: selectedOption && selectedOption.length && selectedOption[0].Id || null,
    OverrideDiscount: selectedOption && selectedOption.length && selectedOption[0].OverrideDiscount ? selectedOption[0].OverrideDiscount : undefined,
    Quantity: 1,
    ItemDecisions: selectedOption && selectedOption[0] && selectedOption[0].Items ? mapQuantityDecisionGroupItems(selectedOption[0].Items) : null
  };
});
var filterUnselectedDecisionGoups = filter(function (decision) {
  return decision.SelectedValue;
});
function getQuantityDecisions(decisionMap) {
  return compose(filterQuantityDecisions, values)(decisionMap);
}
function getQuantityDecisionsGroups(decisionMap) {
  return compose(filterQuantityDecisionGroups, values)(decisionMap);
}
function getStandaloneDecisions(decisionMap) {
  return compose(filterStandaloneDecisions, values)(decisionMap);
}
function getCompletedQuantityDecisions(decisionsMap) {
  return compose(mapQuantityDecision, filterQuantityDecisions, values)(decisionsMap);
}
function getCompletedDecisionGroups(decisionsMap) {
  return compose(filterUnselectedDecisionGoups, mapDecisionGroups, filterDecisionGroups, values)(decisionsMap);
}
function getCompletedQuantityDecisionGroups(decisionsMap) {
  return compose(mapQuantityDecisionGroups, filterQuantityDecisionGroups, values)(decisionsMap);
}
function getCompletedStandaloneDecisions(decisionsMap) {
  return compose(mapStandaloneDecision, filterStandaloneDecisions, values)(decisionsMap);
}
export var DecisionsGroupEmptySelector = createSelector([DecisionsSelector], function (decisionsMap) {
  return isEmpty(mapDecisionGroups(decisionsMap));
});
export var CompletedDecisionsSelector = createSelector([DecisionsSelector], function (decisionsMap) {
  var completedDecision = [];
  var mappedQuantityDecisions = getCompletedQuantityDecisions(decisionsMap);
  var mappedDecisionGroups = getCompletedDecisionGroups(decisionsMap);
  var mappedQuantityDecisionGroups = getCompletedQuantityDecisionGroups(decisionsMap);
  var mappedStandaloneDecisions = getCompletedStandaloneDecisions(decisionsMap);
  var completedQuantityDecisionOptions = mappedQuantityDecisions.reduce(function (accDecisions, quantityDecision) {
    return accDecisions.concat(quantityDecision.completedQuantityOptions);
  }, []);
  var completedQuantityDecisionGroupdOptions = mappedQuantityDecisionGroups.reduce(function (accDecisions, quantityDecision) {
    return accDecisions.concat(quantityDecision.completedQuantityOptions);
  }, []);
  var completedStandaloneDecisionOptions = mappedStandaloneDecisions.reduce(function (accDecisions, standaloneDecision) {
    return accDecisions.concat(standaloneDecision.completedStandaloneOptions);
  }, []);
  completedDecision = concat(completedDecision, mappedDecisionGroups);
  completedDecision = concat(completedDecision, completedQuantityDecisionGroupdOptions);
  completedDecision = concat(completedDecision, completedQuantityDecisionOptions);
  completedDecision = concat(completedDecision, completedStandaloneDecisionOptions);
  return completedDecision;
});
export var DecisionsHasErrorSelector = createSelector([DecisionsSelector], function (decisionsMap) {
  var quantityDecisions = getQuantityDecisions(decisionsMap);
  var quantityDGDecisions = getQuantityDecisionsGroups(decisionsMap);
  var standaloneDecisions = getStandaloneDecisions(decisionsMap);
  var decisionsError = quantityDecisions.reduce(function (hasError, quantityDecision) {
    var isDecisionInvalid = isQuantityDecisionInvalid(quantityDecision.Options);
    return hasError || isDecisionInvalid;
  }, false);
  var decisionsDGError = quantityDGDecisions.reduce(function (hasError, quantityDGDecision) {
    var isDecisionInvalid = isQuantityDecisionGroupsInvalid(quantityDGDecision.Options, quantityDGDecision);
    return hasError || isDecisionInvalid;
  }, false);
  var decisionsDGOIError = quantityDGDecisions.reduce(function (hasError, quantityDGDecision) {
    var isDecisionInvalid = isQuantityDecisionGroupsItemsInvalid(quantityDGDecision.Options);
    return hasError || isDecisionInvalid;
  }, false);
  var decisionsSEError = standaloneDecisions.reduce(function (hasError, standaloneDecision) {
    var isDecisionInvalid = isStandaloneDecisionInvalid(standaloneDecision.Options, standaloneDecision);
    return hasError || isDecisionInvalid;
  }, false);
  return decisionsError || decisionsDGError || decisionsDGOIError || decisionsSEError;
});
export var SelectedOfferNameSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  return selectedOfferingStore.offerName;
});
export var CurrentRemoveOfferSelector = createSelector([SelectedOfferNameSelector, ROCOfferIdDataSelector], function (offerName, offerId) {
  return offerId && offerName ? [{
    name: offerName,
    id: offerId
  }] : IMMUTABLE_EMPTY_ARRAY;
});
export var SelectedPageHasErrorSelector = createSelector([PagesWithDecisionsSelector, SelectedPageIdSelector], function (pages, selectedPage) {
  var currentPage = pages.filter(function (page) {
    return page.Id === selectedPage;
  });
  var dgWithErrors = currentPage.filter(function (element) {
    return element.decisions.some(function (subElement) {
      return subElement.hasError === true;
    });
  });
  return dgWithErrors.length > 0;
});
export var SelectedOfferChangesEffectiveSelector = createSelector([SelectedOfferingSelector], function (offering) {
  return offering.data.changesEffective;
});
var populateExternalContractId = function populateExternalContractId(externalContractId, items) {
  return items ? items.map(function (item) {
    if (item.OrderContractInstance) {
      item.OrderContractInstance.ExternalContractId = externalContractId;
    }
    item.ExternalContractId = externalContractId;
    return item;
  }) : null;
};
export var SelectedOfferPaymentInstrumentSelector = createSelector([SelectedOfferingSelector], function (offering) {
  return offering.data.paymentInstrument;
});
var populatePurchaseOrderNumberAndEffectiveDate = function populatePurchaseOrderNumberAndEffectiveDate(purchaseOrderNumber, items, executionOptions) {
  return items ? items.forEach(function (item) {
    item.PurchaseOrderNumber = purchaseOrderNumber;
    if (executionOptions && executionOptions.billingEffectiveIntention) {
      item.BillingEffectiveDate = executionOptions.billingEffectiveDate;
      item.BillingEffectiveDateIntention = executionOptions.billingEffectiveIntention;
    }
    return item;
  }) : null;
};
var populateOrderContractId = function populateOrderContractId(selectedContract, items) {
  return items ? items.map(function (item) {
    item.OrderContractId = selectedContract.OrderContractId || selectedContract.Id;
    return item;
  }) : null;
};
export var populateDownPaymentAmount = function populateDownPaymentAmount(devicePaymentOptions, items, addOrRemoveItems) {
  var devicePaymentOptionItemsSafe = pathOr([], ['items'], devicePaymentOptions);
  var purchasingItemIndex = 0,
    devicePaymentOptionItemIndex = 0;
  (items || []).forEach(function (item) {
    item.itemIndex = purchasingItemIndex++;
    var _isFinancedShoppingCa = isFinancedShoppingCartItem(item),
      isFinancedItem = _isFinancedShoppingCa.isFinancedItem,
      minimumDownPayment = _isFinancedShoppingCa.minimumDownPayment,
      isFullUpfrontPayment = _isFinancedShoppingCa.isFullUpfrontPayment;
    if (isFinancedItem) {
      item.isFullUpfrontPayment = isFullUpfrontPayment;
      item.minimumDownPayment = minimumDownPayment;
      setDownPaymentProperties(item, item.minimumDownPayment, null, false);
    }
  });
  // Add/Remove Items will be present only when Editing/Transitioning an Offer
  (addOrRemoveItems || []).forEach(function (item) {
    item.itemIndex = purchasingItemIndex++;
    var _isFinancedShoppingCa2 = isFinancedShoppingCartItem(item),
      isFinancedItem = _isFinancedShoppingCa2.isFinancedItem,
      minimumDownPayment = _isFinancedShoppingCa2.minimumDownPayment,
      isFullUpfrontPayment = _isFinancedShoppingCa2.isFullUpfrontPayment;
    if (isFinancedItem) {
      item.isFullUpfrontPayment = isFullUpfrontPayment;
      item.minimumDownPayment = minimumDownPayment;
      var downPayment = item.minimumDownPayment,
        financedFullAmount = null,
        isFullPriceDownPaymentSelected = false;
      var devicePaymentOptionItem = devicePaymentOptionItemsSafe[devicePaymentOptionItemIndex];
      if (devicePaymentOptionItemsSafe.length && devicePaymentOptionItem) {
        downPayment = devicePaymentOptionItem.downPayment;
        financedFullAmount = devicePaymentOptionItem.financedFullAmount;
        isFullPriceDownPaymentSelected = devicePaymentOptionItem.isFullPriceDownPaymentSelected;
        devicePaymentOptionItemIndex++;
      }
      setDownPaymentProperties(item, downPayment, financedFullAmount, isFullPriceDownPaymentSelected);
    }
  });
  devicePaymentOptionItemsSafe.forEach(function (devicePaymentOptionItem) {
    var item = items[devicePaymentOptionItem.itemIndex];
    setDownPaymentProperties(item, devicePaymentOptionItem.downPayment, devicePaymentOptionItem.financedFullAmount, devicePaymentOptionItem.isFullPriceDownPaymentSelected);
  });
};
export var HasBulkShoppingCartItem = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  var shoppingCartItems = pathOr([], ['data', 'shoppingCart', 'Items'], selectedOfferingStore);
  return Immutable(!shoppingCartItems.length ? false : shoppingCartItems.some(function (item) {
    var billerRuleInstances = [].concat(_toConsumableArray(item.Details.PricingPlan.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances), _toConsumableArray(item.Details.PricingPlan.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances));
    return billerRuleInstances.some(function (bri) {
      return bri.BulkChargeTypeCode;
    });
  }));
});
export var AddItemsSelector = createSelector([ShoppingCartSelector], function (shoppingCart) {
  return pathOr(null, ['AddItems'], shoppingCart);
});
export var ModifyItemsSelector = createSelector([ShoppingCartSelector], function (shoppingCart) {
  return pathOr(null, ['ModifyItems'], shoppingCart);
});
export var ShoppingCartIsPostpaidSelector = createSelector([ShoppingCartSelector], function (shoppingCartSelector) {
  if (shoppingCartSelector.Items) {
    return any(function (item) {
      return !item.Details.PricingPlan.Prepaid;
    })(shoppingCartSelector.Items);
  }
  return false;
});
export var PaymentInstrumentRequiredSelector = createSelector([ShoppingCartSelector], function (cart) {
  return cart.PaymentInstrumentRequired || false;
});
export var HasOffCycleChargeRenewalSelector = createImmutableSelector([ShoppingCartSelector], function (cart) {
  return cart.HasOffCycleChargeRenewal || false;
});
export var ShoppingCartHaveOnlyStandaloneItemsSelector = createSelector([ShoppingCartSelector], function (shoppingCart) {
  var shoppingCartItems = pathOr([], ['Items'], shoppingCart);
  var standaloneItems = shoppingCartItems.filter(function (item) {
    return item && item.IsStandalone === true;
  });
  return shoppingCartItems.length > 0 && standaloneItems.length === shoppingCartItems.length;
});
export var IsSaveOrderButtonDisabledSelector = createSelector([ShoppingCartHaveOnlyStandaloneItemsSelector, ShoppingCartSelector], function (shoppingCartHaveOnlyStandaloneItems, shoppingCart) {
  return shoppingCartHaveOnlyStandaloneItems || !(shoppingCart.Items && shoppingCart.Items.length);
});
export var SaveOrderButtonTooltipTextSelector = createSelector([ShoppingCartHaveOnlyStandaloneItemsSelector, ShoppingCartSelector], function (shoppingCartHaveOnlyStandaloneItems, shoppingCart) {
  var tooltipText = '';
  if (!(shoppingCart.Items && shoppingCart.Items.length)) {
    tooltipText = i18n.translate(CustomerCareKeys.SAVE_CART.CART_IS_EMPTY);
  } else if (shoppingCartHaveOnlyStandaloneItems) {
    tooltipText = i18n.translate(CustomerCareKeys.SAVE_CART.CART_IS_HAVING_ONLY_STANDALONE_PRODUCTS);
  }
  return tooltipText;
});
export var TelephoneNumberProvinceRegionSelector = createSelector([MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.TelephoneCodes), MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressStateProvinceRegion), CustomerInfoSelector, SelectedCustomerHomeCountrySelector, CurrentBusinessUnitSelector], function (codes, stateNames, newConnectCustomerInfo, existingCustomerInfoHomeCountry, businessUnit) {
  //Look for selected country
  var selectedCountry = newConnectCustomerInfo.HomeCountry || existingCustomerInfoHomeCountry || businessUnit.defaultCountry;
  var filteredStates = filterStatesByCountry(stateNames, selectedCountry);
  var result = compose(reduceByState, mapCodesAdditionalProperties, filterByCountry)(codes, selectedCountry);
  return Immutable(findAndAttachStateName(result, filteredStates));
});
export var generateKeyFromInventoryItem = function generateKeyFromInventoryItem(item, index) {
  return "InventoryTypeId-".concat(item.InventoryTypeId, "-MakeId-").concat(item.MakeId, "-ModelId-").concat(item.ModelId, "-Index-").concat(index);
};
export var FilteredStoresOnSelectedRegionSelector = createImmutableSelector([InventoryStoresTableDataSelector, SelectedInventoryRegionSelector], function (stores, selectedRegion) {
  if (selectedRegion) {
    return stores.filter(function (store) {
      return store.region === selectedRegion;
    });
  }
  return EMPTY_ARRAY;
});
export var FilteredStoresOnSelectedRegionForStoresSearchModalSelector = createImmutableSelector([FormattedInventoryStoresSelector, FilteredStoresOnSelectedRegionSelector, InventoryRegionFilterSelector], function (allStores, storesForRegionforCurrentlySelectedStore, regionFilter) {
  //regionFilter gets set to null when exiting a store select modal.
  if (regionFilter) {
    var filteredStores = allStores.filter(function (store) {
      return store.AdditionalProperties.RegionCode === regionFilter;
    });
    return filteredStores.map(function (store) {
      return {
        displayName: store.AdditionalProperties.DisplayName,
        address: store.AdditionalProperties.LineOne,
        city: store.AdditionalProperties.City,
        postalCode: store.AdditionalProperties.Zipcode,
        stateProvince: store.AdditionalProperties.stateProvince,
        storeId: store.Value
      };
    });
  } else {
    return storesForRegionforCurrentlySelectedStore;
  }
});
export var SelectedOfferingPhysicalInventoryAvailabilitySelector = createImmutableSelector([AllPhysicalInventoryItemsFromSelectedOffering, SelectedInventoryRegionSelector, InventoryRegionFilterSelector], function (allPhysicalInventoryItemsFromSelectedOffering, selectedRegionFromCurrentlySelectedStore, currentlySelectedRegion) {
  return !allPhysicalInventoryItemsFromSelectedOffering || !selectedRegionFromCurrentlySelectedStore ? null : {
    InventoryTypes: allPhysicalInventoryItemsFromSelectedOffering,
    RegionId: currentlySelectedRegion ? currentlySelectedRegion : selectedRegionFromCurrentlySelectedStore
  };
});
export var SelectedOfferingStoreAvailabilitySelector = createImmutableSelector([InventoryAvailabilitySelector, FilteredStoresOnSelectedRegionForStoresSearchModalSelector, AllPhysicalInventoryItemsFromSelectedOffering], function (availableInventoryForStores, stores, allPhysicalInventoryItemsFromSelectedOffering) {
  var areRegionsInSync = false;
  if (availableInventoryForStores && stores) {
    areRegionsInSync = availableInventoryForStores && availableInventoryForStores[0] && stores ? stores.find(function (store) {
      return store.storeId === availableInventoryForStores[0].StoreId;
    }) : false;
  }
  if (availableInventoryForStores && allPhysicalInventoryItemsFromSelectedOffering && stores && areRegionsInSync) {
    return allPhysicalInventoryItemsFromSelectedOffering.map(function (inventoryItem) {
      var storeAvailForInventoryItem = [];
      stores.forEach(function (store) {
        var itemAvailabilityAtStoreResponse = availableInventoryForStores.find(function (inventoryStatusAtStore) {
          return inventoryStatusAtStore.InstanceId === inventoryItem.InstanceId && inventoryStatusAtStore.StoreId === store.storeId;
        });
        if (itemAvailabilityAtStoreResponse) {
          storeAvailForInventoryItem.push({
            storeId: store.storeId,
            AvailableUnits: itemAvailabilityAtStoreResponse.AvailableUnits,
            RequestedQuantity: itemAvailabilityAtStoreResponse.RequestedQuantity,
            MeetsRequestedQuantity: itemAvailabilityAtStoreResponse.MeetsRequestedQuantity
          });
        }
      });
      return {
        DisplayName: inventoryItem.DisplayName,
        InstanceId: inventoryItem.InstanceId,
        InventoryAttributes: inventoryItem.InventoryAttributes,
        InventoryTypeId: inventoryItem.InventoryTypeId,
        MakeId: inventoryItem.MakeId,
        ModelId: inventoryItem.ModelId,
        Quantity: 1,
        stores: storeAvailForInventoryItem
      };
    });
  }
  return EMPTY_ARRAY;
});
export var IsAllSelectedPhysicalInventoryPresentAtSelectedStore = createImmutableSelector([InventoryAvailabilitySelector, SelectedInventoryStoresSelector], function (inventoryAvailabilityForSelectedInventoryItemsAtSelectedStores, selectedStores) {
  return inventoryAvailabilityForSelectedInventoryItemsAtSelectedStores.filter(function (inventoryAvailabilityAtStore) {
    return selectedStores.some(function (storeId) {
      return inventoryAvailabilityAtStore.StoreId === storeId;
    });
  }).some(function (inventoryAvailabilityAtSelectedStore) {
    return !inventoryAvailabilityAtSelectedStore.MeetsRequestedQuantity;
  }) ? false : true;
});
export var LifeCycleDetailsForPricingPlanSelector = createImmutableSelector([OfferingMetadataByIdSelector, ROCOfferIdDataSelector], function (offeringMedata, offerId) {
  if (offeringMedata && offeringMedata[offerId]) {
    return pluck('LifeCycles', offeringMedata[offerId].Options).filter(function (element) {
      return undefined !== element;
    });
  } else {
    return EMPTY_ARRAY;
  }
});
export var ActiveLifeCycleSelector = createImmutableSelector([LifeCycleDetailsForPricingPlanSelector], function (lifeCycle) {
  var allLifeCycles = [];
  lifeCycle.forEach(function (lifeCycleDetails) {
    if (lifeCycleDetails !== null && lifeCycleDetails !== undefined && lifeCycleDetails.length && lifeCycleDetails[0].Status === GENERAL_STATUSES.ACTIVE) {
      allLifeCycles.push(lifeCycleDetails);
    }
  });
  return allLifeCycles;
});
var sortMultipleLifeCycles = function sortMultipleLifeCycles(multipleLifeCycles) {
  var sortedLifeCycles = [];
  var sortByWeight = sortWith([descend(prop('Weight'))]);
  var sortByName = sortWith([prop('Name')]);
  var lifeCycleWithWeight = [];
  var lifeCycleWithoutWeight = [];
  multipleLifeCycles.forEach(function (lifeCycleItem) {
    if (lifeCycleItem.Weight) {
      lifeCycleWithWeight.push(lifeCycleItem);
    } else {
      lifeCycleWithoutWeight.push(lifeCycleItem);
    }
  });
  var filteredArray = lifeCycleWithWeight;
  var duplicateArray = [];
  lifeCycleWithWeight.forEach(function (item1) {
    var matchingItems = filteredArray.filter(function (item2) {
      return item2.Weight === item1.Weight;
    });
    if (matchingItems.length > 1) {
      duplicateArray = duplicateArray.concat(matchingItems);
      var newArray = filteredArray.filter(function (filteredItem) {
        return filteredItem.Weight !== matchingItems[0].Weight;
      });
      filteredArray = newArray;
    }
  });
  var lifeCycleSortedWithWeights = [].concat(_toConsumableArray(filteredArray), _toConsumableArray(sortByName(duplicateArray)));
  sortedLifeCycles = [].concat(_toConsumableArray(sortByWeight(lifeCycleSortedWithWeights)), _toConsumableArray(sortByName(lifeCycleWithoutWeight)));
  return sortedLifeCycles;
};
export var LifeCyclesForProductsSelector = createImmutableSelector([ActiveLifeCycleSelector, DecisionsSelector], function (lifeCycles, decisions) {
  var decisionWithLifeCycles = [];
  flatten(values(decisions)).forEach(function (decision) {
    lifeCycles.forEach(function (lifeCycleInfo) {
      if (lifeCycleInfo.length > 1) {
        var multipleLifeCycles = [];
        flatten(lifeCycleInfo).forEach(function (lifeCycle) {
          if (decision.ProductId === lifeCycle.ProductId) {
            multipleLifeCycles.push(lifeCycle);
          }
        });
        if (multipleLifeCycles.length) {
          decisionWithLifeCycles.push({
            productId: decision.ProductId,
            lifeCycles: sortMultipleLifeCycles(multipleLifeCycles)
          });
        }
      } else if (decision.ProductId === lifeCycleInfo[0].ProductId) {
        decisionWithLifeCycles.push({
          productId: lifeCycleInfo[0].ProductId,
          lifeCycles: [lifeCycleInfo[0]]
        });
      }
    });
  });
  return decisionWithLifeCycles;
});
export var LifeCycleStepsPricingPlanSelector = createSelector([ActiveLifeCycleSelector, DecisionsSelector, OfferingMetadataPricingPlansSelector], function (lifeCycle, decisionMap, pricingPlanThumbnail) {
  var lifeCycleSteps = [];
  flatten(values(decisionMap)).forEach(function (decision) {
    flatten(lifeCycle).forEach(function (lifeCycleInfo) {
      if (decision.ProductId === lifeCycleInfo.ProductId) {
        lifeCycleSteps.push({
          productId: lifeCycleInfo.ProductId,
          steps: lifeCycleInfo.Steps
        });
      }
    });
  });
  var pricingPlanInPricingPlanThumbnail = pricingPlanThumbnail ? Object.values(pricingPlanThumbnail).filter(function (pricingPlan) {
    return lifeCycleSteps.length ? lifeCycleSteps.find(function (lifeCyclePricingPlan) {
      return lifeCyclePricingPlan.productId === pricingPlan.ProductId;
    }) : EMPTY_ARRAY;
  }) : EMPTY_ARRAY;
  var lifeCyclePricingPlanInPricingPlanThumbnail = pricingPlanInPricingPlanThumbnail.filter(function (pricingPlanThumbnail) {
    return lifeCycleSteps ? flatten(pluck('steps', lifeCycleSteps)).find(function (lifeCyclePricingPlan) {
      return lifeCyclePricingPlan.PricingPlanId === pricingPlanThumbnail.PricingPlanBillerRuleInstances.PricingPlanId;
    }) : EMPTY_ARRAY;
  });
  return lifeCyclePricingPlanInPricingPlanThumbnail;
});
var getBriDetails = function getBriDetails(bri, briName) {
  var isBothRbriAndObriPresent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (bri.length > 1 && isBothRbriAndObriPresent) {
    var briInfo = [];
    bri.forEach(function (billerRuleDetails) {
      briInfo.push({
        Name: briName[billerRuleDetails.Type].Name,
        Amount: getChargeAmount(billerRuleDetails.BillerRuleInstanceCharges),
        Type: billerRuleDetails.Type
      });
    });
    return briInfo;
  } else if (bri.length > 1 && !isBothRbriAndObriPresent) {
    var briDetails = [];
    bri.forEach(function (billerRuleDetails) {
      briDetails.push({
        Name: billerRuleDetails.Name,
        Amount: getChargeAmount(billerRuleDetails.BillerRuleInstanceCharges),
        Type: billerRuleDetails.Type
      });
    });
    return briDetails;
  } else {
    return [{
      Name: briName.Name,
      Amount: getChargeAmount(bri[0].BillerRuleInstanceCharges),
      Type: bri[0].Type
    }];
  }
};
var getBillerRuleInstancesForPricingPlanInLifeCycle = function getBillerRuleInstancesForPricingPlanInLifeCycle(pricingPlanInLifeCycle, oneTimeBri, recurringBri, stepsDetails) {
  var pricingPlanThumbnailInLifeCycle = [];
  pricingPlanInLifeCycle ? pricingPlanInLifeCycle.forEach(function (lifeCycleDetails) {
    if (lifeCycleDetails.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances.length && lifeCycleDetails.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances.length) {
      var oneTimeBriName = oneTimeBri.find(function (briName) {
        return lifeCycleDetails.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances[0].BillerRuleConfigurationId === briName.Value;
      });
      var recurringBriName = recurringBri.find(function (briName) {
        return lifeCycleDetails.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances[0].BillerRuleConfigurationId === briName.Value;
      });
      pricingPlanThumbnailInLifeCycle.push(_defineProperty({}, lifeCycleDetails.Id, {
        pricingPlanInfo: lifeCycleDetails,
        billerRuleInstances: getBriDetails([].concat(_toConsumableArray(lifeCycleDetails.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances), _toConsumableArray(lifeCycleDetails.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances)), _defineProperty(_defineProperty({}, BILLER_RULE_INSTANCE_TYPE.ONETIME, oneTimeBriName), BILLER_RULE_INSTANCE_TYPE.RECURRING, recurringBriName), true),
        durationCount: Object.keys(stepsDetails).length ? stepsDetails[lifeCycleDetails.Id].DurationCount : []
      }));
    } else if (lifeCycleDetails.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances.length) {
      var _oneTimeBriName = oneTimeBri.find(function (briName) {
        return lifeCycleDetails.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances[0].BillerRuleConfigurationId === briName.Value;
      });
      pricingPlanThumbnailInLifeCycle.push(_defineProperty({}, lifeCycleDetails.Id, {
        pricingPlanInfo: lifeCycleDetails,
        billerRuleInstances: getBriDetails(lifeCycleDetails.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances, _oneTimeBriName),
        durationCount: Object.keys(stepsDetails).length ? stepsDetails[lifeCycleDetails.Id].DurationCount : []
      }));
    } else if (lifeCycleDetails.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances.length) {
      var _recurringBriName = recurringBri.find(function (briName) {
        return lifeCycleDetails.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances[0].BillerRuleConfigurationId === briName.Value;
      });
      pricingPlanThumbnailInLifeCycle.push(_defineProperty({}, lifeCycleDetails.Id, {
        pricingPlanInfo: lifeCycleDetails,
        billerRuleInstances: getBriDetails(lifeCycleDetails.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances, _recurringBriName),
        durationCount: Object.keys(stepsDetails).length ? stepsDetails[lifeCycleDetails.Id].DurationCount : []
      }));
    }
  }) : EMPTY_ARRAY;
  return pricingPlanThumbnailInLifeCycle;
};
export var DecisionsLifeCycleStepsForOffersSelector = createImmutableSelector([LifeCycleStepsPricingPlanSelector, ActiveLifeCycleSelector], function (pricingPlanInLifeCycle, lifeCycles) {
  var filteredLifeCyclePricingPlans = pluck('Steps', flatten(lifeCycles)).filter(function (lifeCycle) {
    return lifeCycle.find(function (lifeCyclePricingPlan) {
      return pricingPlanInLifeCycle.find(function (pricingPlan) {
        return pricingPlan.Id === lifeCyclePricingPlan.PricingPlanId;
      });
    });
  });
  return flatten(filteredLifeCyclePricingPlans).reduce(function (acc, current) {
    return acc[current.PricingPlanId] = current, acc;
  }, {});
});
export var PricingPlanChargeDetailsSelector = createImmutableSelector([LifeCycleStepsPricingPlanSelector, MetadataCodeTypeSelector(CODES.RecurringBillerRuleConfiguration), MetadataCodeTypeSelector(CODES.OneTimeBillerRuleConfiguration), DecisionsLifeCycleStepsForOffersSelector], function (pricingPlanInLifeCycle, recurringBillerRuleConfiguration, oneTimeBillerRuleConfiguration, stepsDetails) {
  return getBillerRuleInstancesForPricingPlanInLifeCycle(pricingPlanInLifeCycle, oneTimeBillerRuleConfiguration, recurringBillerRuleConfiguration, stepsDetails);
});
export var PricingPlanInLifeCycleForOffersSelector = createImmutableSelector([CustomerStoreSelector, OfferingMetadataByIdSelector, OfferingMetadataPricingPlansSelector], function (customerStore, offeringMedata, pricingPlanThumbnail) {
  if (customerStore.lifeCycleDetails && Object.keys(offeringMedata).length && offeringMedata[customerStore.lifeCycleDetails.offerId]) {
    var lifeCycleDetailsInMetadata = flatten(pluck('LifeCycles', offeringMedata[customerStore.lifeCycleDetails.offerId].Options)).find(function (lifeCycle) {
      if (lifeCycle) {
        return lifeCycle.Id === customerStore.lifeCycleDetails.lifeCycleId;
      }
    });
    var filteredMetadataPricingPlans = [];
    Object.values(pricingPlanThumbnail).forEach(function (pricingPlan) {
      lifeCycleDetailsInMetadata ? lifeCycleDetailsInMetadata.Steps.find(function (step) {
        if (step.PricingPlanId === pricingPlan.Id) {
          filteredMetadataPricingPlans.push(_objectSpread(_objectSpread({}, pricingPlan), {}, {
            sortIndex: step.StepNumber
          }));
          return step.PricingPlanId === pricingPlan.Id;
        }
      }) : EMPTY_ARRAY;
    });
    return filteredMetadataPricingPlans.sort(function (a, b) {
      return a.sortIndex - b.sortIndex;
    });
  }
});
export var DashBoardLifeCycleStepsForOffersSelector = createImmutableSelector([CustomerStoreSelector, OfferingMetadataByIdSelector], function (customerStore, offeringMedata) {
  if (customerStore.lifeCycleDetails && Object.keys(offeringMedata).length && offeringMedata[customerStore.lifeCycleDetails.offerId]) {
    var lifeCycleDetailsInMetadata = flatten(pluck('LifeCycles', offeringMedata[customerStore.lifeCycleDetails.offerId].Options)).find(function (lifeCycle) {
      if (lifeCycle) {
        return lifeCycle.Id === customerStore.lifeCycleDetails.lifeCycleId;
      }
    });
    var lifeCycleSteps = lifeCycleDetailsInMetadata ? lifeCycleDetailsInMetadata.Steps.reduce(function (acc, current) {
      return acc[current.PricingPlanId] = current, acc;
    }, {}) : EMPTY_OBJECT;
    return lifeCycleSteps;
  }
});
export var LifeCyclePricingPlanDetailsSelector = createImmutableSelector([PricingPlanInLifeCycleForOffersSelector, MetadataCodeTypeSelector(CODES.RecurringBillerRuleConfiguration), MetadataCodeTypeSelector(CODES.OneTimeBillerRuleConfiguration), DashBoardLifeCycleStepsForOffersSelector], function (pricingPlanInLifeCycle, recurringBillerRuleConfiguration, oneTimeBillerRuleConfiguration, stepsDetails) {
  return getBillerRuleInstancesForPricingPlanInLifeCycle(pricingPlanInLifeCycle, oneTimeBillerRuleConfiguration, recurringBillerRuleConfiguration, stepsDetails);
});
export var CartContainsOfferWithBillerRuleCycleLevelOtherThanItemSelector = createImmutableSelector([ShoppingCartSelector, OfferingMetadataByIdSelector], function (shoppingCart, offeringMetadataById) {
  return (shoppingCart.Items || []).some(function (item) {
    return (offeringMetadataById[item.OfferingId] || {}).BillerRuleCycleLevel !== BILLER_RULE_CYCLE_LEVEL.ITEM;
  });
});
export var CartContainsOffcycleOfferSelector = createImmutableSelector([ShoppingCartSelector, OfferingMetadataByIdSelector], function (shoppingCart, offeringMetadataById) {
  return (shoppingCart.Items || []).some(function (item) {
    return (offeringMetadataById[item.OfferingId] || {}).BillerRuleCycleLevel === BILLER_RULE_CYCLE_LEVEL.ITEM;
  });
});
export var SelectedDeliveryDecisionFromRocSelector = createSelector([SelectedOfferingSelector], function (selectedOfferingStore) {
  if (selectedOfferingStore.data.deliveryDecisions) {
    var selectedDecisions = selectedOfferingStore.data.deliveryDecisions.find(function (item) {
      return !!item.SelectedValue;
    });
    return selectedDecisions ? selectedDecisions.SelectedValue : undefined;
  }
});
export var ServiceTaxCustomizationHashSelector = createImmutableSelector([AttributesDataSelector], function (attributes) {
  return attributes.serviceTaxCustomizationHash;
});